/**
 * 微信配置注入
 */
import api from '../../api'
import store from '../../store'
import wx from '../../plugin/wxjssdk'

const COMMON_JSAPI = ['hideMenuItems','closeWindow']

const handleWxConfig = (jsApiList = []) => {
  return new Promise((resolve,reject) => {
    // 进行微信sdk权限注册
    const url = store.state.wxurl.wxConfUrl
    // 网络请求获取微信配置
    api
      .getJssdkConfig(url)
      .then(res => {
        const data = res.data || {}
        wx.config({
          debug: false,
          appId: data.app_id,
          nonceStr: data.nonce_str,
          signature: data.signature,
          timestamp: data.timestamp,
          jsApiList: [...jsApiList,...COMMON_JSAPI]
        })

        wx.ready(() => {
          // 隐藏页面功能
          wx.hideMenuItems({
            menuList: [
              'menuItem:copyUrl',
              'menuItem:share:qq',
              'menuItem:share:weiboApp',
              'menuItem:share:QZone',
              'menuItem:openWithSafari',
              'menuItem:openWithQQBrowser'
            ]
          })
          resolve()
        })

        wx.error(err => {
          reject(err)
        })
      })
      .catch(err => {
        reject(err)
      })
  })
}

export default handleWxConfig
